import { v4 as uuidv4 } from 'uuid';
import { formatFileSize, createDefaultFileDownloadSettings, normalizeFileDownloadSettings } from './localFile.js';
import { formatAudioDuration } from './localAudio.js';
import {
	isLocalMediaItem,
	normalizeUploadedVideoItem,
	pickFilesizeByte,
	pickFilesizeLabel,
} from './mediaItem.js';

/** 为 false 时走 uploadMediaToQiniu 真实上传 */
export const USE_LOCAL_VIDEO_MOCK = false;

export const MAX_LOCAL_VIDEO_COUNT = 1;
export const MAX_LOCAL_VIDEO_SIZE = 500 * 1024 * 1024;

const VIDEO_EXT = /\.(mp4|mov|avi|flv|mkv|webm|m4v|wmv)$/i;

export function isVideoFilename(filename = '') {
	return VIDEO_EXT.test(filename);
}

export function formatVideoDuration(totalSeconds = 0) {
	return formatAudioDuration(totalSeconds);
}

export function createLocalVideoItem(file) {
	const previewUrl = URL.createObjectURL(file);
	const baseItem = {
		id: uuidv4(),
		filename: file.name || '',
		filesize: formatFileSize(file.size),
		filesize_byte: file.size,
		previewUrl,
		duration: 0,
		durationText: '00:00',
		url: '',
		local: true,
	};

	return new Promise((resolve) => {
		const video = document.createElement('video');
		video.preload = 'metadata';
		video.onloadedmetadata = () => {
			const duration = Number.isFinite(video.duration) ? Math.floor(video.duration) : 0;
			resolve({
				...baseItem,
				duration,
				durationText: formatVideoDuration(duration),
			});
		};
		video.onerror = () => {
			resolve(baseItem);
		};
		video.src = previewUrl;
	});
}

export function revokeLocalVideoItem(item) {
	if (item?.previewUrl?.startsWith('blob:')) {
		URL.revokeObjectURL(item.previewUrl);
	}
}

export function revokeLocalVideos(items = []) {
	items.forEach(revokeLocalVideoItem);
}

export function filterValidLocalVideoList(files = [], maxCount = MAX_LOCAL_VIDEO_COUNT) {
	const valid = [];
	for (const file of files) {
		if (!file) continue;
		if (file.size > MAX_LOCAL_VIDEO_SIZE) continue;
		valid.push(file);
		if (valid.length >= maxCount) break;
	}
	return valid;
}

export function normalizeLocalVideoItem(item = {}) {
	if (!isLocalMediaItem(item)) {
		return normalizeUploadedVideoItem(item);
	}
	const duration = item.duration || 0;
	return {
		id: item.id || uuidv4(),
		filename: item.filename || '',
		filesize: pickFilesizeLabel(item),
		filesize_byte: pickFilesizeByte(item),
		previewUrl: item.previewUrl || '',
		duration,
		durationText: item.durationText || formatVideoDuration(duration),
		url: '',
		local: true,
	};
}

export function normalizeLocalVideos(items = []) {
	return items.slice(0, MAX_LOCAL_VIDEO_COUNT).map(normalizeLocalVideoItem);
}

export function normalizeHeaderVideos(data = {}) {
	const items = normalizeLocalVideos(data.items);
	const firstItem = items[0];
	return {
		title: data.title || firstItem?.filename || '',
		items,
		downloadSettings: normalizeFileDownloadSettings(
			data.downloadSettings || createDefaultFileDownloadSettings(),
		),
	};
}

export function getHeaderVideoItem(data = {}) {
	return normalizeHeaderVideos(data).items[0] || null;
}
